export default "__VITE_ASSET__D3$CfajC__"